<template lang="pug">
.admin  
  v-toolbar(
    color="info"
    fixed
    clipped-left
    app
    dark)
    v-toolbar-side-icon.hidden-md-and-up(@click="toggleNav")
    v-toolbar-title 桃園市屏東同鄉會幹部系統 v1.0.0
  the-admin-nav(ref="nav")
  v-content
    router-view    
</template>

<script>
import TheAdminNav from "@/components/TheAdminNav.vue";

export default {
  name: "Admin",
  components: {
    TheAdminNav
  },
  methods: {
    toggleNav() {
      this.$refs.nav.toggle();
    }
  }
};
</script>
